import { CalendarAdd, CalendarCheck, CalendarPrivacy } from '@griply/assets';
import React from 'react';

// The glyph for a task's calendar-sync state, shared by every surface that
// draws one (the event-card badge, the task-detail header button) so they
// can't end up showing different icons for the same state.
export const getCalendarSyncIcon = (
  isSynced: boolean,
  isHidden: boolean,
): React.FunctionComponent<React.SVGProps<SVGSVGElement>> => {
  if (!isSynced) {
    return CalendarAdd;
  }

  return isHidden ? CalendarPrivacy : CalendarCheck;
};
